import { Button, Form, FormGroup, Input } from '@/platform/ui';
import { useForm } from '@inertiajs/react';

const PasswordForm = () => {
    const { data, setData, put, errors, processing, reset } = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    });

    const handleSubmit = () => {
        put('/user/password', {
            errorBag: 'updatePassword',
            preserveScroll: true,
            onSuccess: () => reset(),
        });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormGroup>
                <Input
                    label='Oude wachtwoord'
                    type='password'
                    autoComplete='current-password'
                    value={data.current_password}
                    onChange={event =>
                        setData('current_password', event.target.value)
                    }
                    error={errors.current_password}
                />
                <Input
                    label='Nieuwe wachtwoord'
                    type='password'
                    autoComplete='new-password'
                    value={data.password}
                    onChange={event => setData('password', event.target.value)}
                    error={errors.password}
                />
                <Input
                    label='Bevestig wachtwoord'
                    type='password'
                    autoComplete='new-password'
                    value={data.password_confirmation}
                    onChange={event =>
                        setData('password_confirmation', event.target.value)
                    }
                    error={errors.password_confirmation}
                />
            </FormGroup>
            <div className='mt-4 flex items-center justify-end'>
                <Button type='submit' variant='primary' loading={processing}>
                    Vernieuw wachtwoord
                </Button>
            </div>
        </Form>
    );
};

export default PasswordForm;
